export enum EPlatformName {
  GEOTAB = "GEOTAB",
  TRIMBLE = "TRIMBLE",
  WEBFLEET = "WEBFLEET",
  WIALON = "WIALON",
  SAMSARA = "SAMSARA",

  MOTIVE = "MOTIVE",
  AZUGA = "AZUGA",
  AZUGA_ELD = "AZUGA_ELD",
  WORKWAVE = "WORKWAVE",
  VERIZON = "VERIZON",
  GPS_INSIGHT = "GPS_INSIGHT",
  ELITEGPS = "ELITEGPS",
  WEX_TELEMATICS = "WEX_TELEMATICS",
  MIX_TELEMATICS = "MIX_TELEMATICS",
  EROAD = "EROAD",
  FLEET_COMPLETE = "FLEET_COMPLETE",
  TELUS = "TELUS",
  BIGROAD = "BIGROAD",
  LION_EIGHT = "LION_EIGHT",
  LYTX = "LYTX",
  OMNITRACS = "OMNITRACS",
  ISAAC = "ISAAC",
  NETRADYNE = "NETRADYNE",
  NEXTRAQ = "NEXTRAQ",
  ONE_STEP_GPS = "ONE_STEP_GPS",
  FLEETLOCATE_SPIREON_NSPIRE = "FLEETLOCATE_SPIREON_NSPIRE",
  XRS = "XRS",
  ZONAR = "ZONAR",
  ORBCOMM_ELD = "ORBCOMM_ELD",
  ORBCOMM_BLUE_TREE = "ORBCOMM_BLUE_TREE",
  VISION_TRACK = "VISION_TRACK",
  WAYLENS = "WAYLENS",
  INSIGHT_MOBILE_DATA = "INSIGHT_MOBILE_DATA",
  MONARCH_GPS = "MONARCH_GPS",
  RHINO = "RHINO",
  TOUCHTEL_GPS = "TOUCHTEL_GPS",
  TRUCKSPY = "TRUCKSPY",
  GPS_COMMANDER = "GPS_COMMANDER",
  ATNT_FLEET_COMPLETE = "ATNT_FLEET_COMPLETE",
  FLEET_UP = "FLEET_UP",
  ACTSOFT_ENCORE = "ACTSOFT_ENCORE",
  ADVANTAGE_ASSET_TRACKING = "ADVANTAGE_ASSET_TRACKING",
  ARGOS_CONNECTED_SOLUTIONS = "ARGOS_CONNECTED_SOLUTIONS",
  ARI_FLEET = "ARI_FLEET",
  ASSURED_TELEMATICS = "ASSURED_TELEMATICS",
  ATNT_FLEET = "ATNT_FLEET",
  ATTRIX = "ATTRIX",
  BADGER_FLEET_SOLUTIONS = "BADGER_FLEET_SOLUTIONS",
  BAR_CODING_CANADA = "BAR_CODING_CANADA",
  BLUEARROW = "BLUEARROW",
  CARRIERHQ = "CARRIERHQ",
  ENVUE_TELEMATICS = "ENVUE_TELEMATICS",
  FLEET_NAV_SYSTEMS = "FLEET_NAV_SYSTEMS",
  FLEET_PROFIT_CENTER = "FLEET_PROFIT_CENTER",
  FLEETBOSS_GPS = "FLEETBOSS_GPS",
  FLEETHOSTER = "FLEETHOSTER",
  FLEETISTICS = "FLEETISTICS",
  FLEETLOCATE_GEOTAB = "FLEETLOCATE_GEOTAB",
  FLEETMASTER = "FLEETMASTER",
  FLEXPORT = "FLEXPORT",
  GEOFORCE = "GEOFORCE",
  GLOSTONE = "GLOSTONE",
  GOFLEET = "GOFLEET",
  GOGPS = "GOGPS",
  GPS_FLEET_FINDER = "GPS_FLEET_FINDER",
  GPS_SOLUTIONS = "GPS_SOLUTIONS",
  GPS_TRACKING_CANADA = "GPS_TRACKING_CANADA",
  GRAYBOX_SOLUTIONS = "GRAYBOX_SOLUTIONS",
  GRIDLINE = "GRIDLINE",
  HIGHPOINT_GPS = "HIGHPOINT_GPS",
  IOTAB = "IOTAB",
  LYNX = "LYNX",
  ONTRAK_SOLUTIONS = "ONTRAK_SOLUTIONS",
  PENSKE = "PENSKE",
  PREPASS_ELD = "PREPASS_ELD",
  QUALITY_GPS = "QUALITY_GPS",
  RMJ_TECHNOLOGIES = "RMJ_TECHNOLOGIES",
  RUSH_ENTERPRISES = "RUSH_ENTERPRISES",
  RYDER = "RYDER",
  SAFETY_VISION = "SAFETY_VISION",
  SHELL_TELEMATICS = "SHELL_TELEMATICS",
  SURECAM = "SURECAM",
  T_MOBILE = "T_MOBILE",
  TRANSFLO = "TRANSFLO",
  TRAXXISGPS = "TRAXXISGPS",
  VERTRAX = "VERTRAX",
  ZENDUIT = "ZENDUIT",
  HOLMAN = "HOLMAN",
  ENTERPRISE_FLEET_MANAGEMENT = "ENTERPRISE_FLEET_MANAGEMENT",
  DICAN = "DICAN",
  ADVANTAGE_ONE = "ADVANTAGE_ONE",
  EAGLE_WIRELESS = "EAGLE_WIRELESS",
  LINXUP = "LINXUP",
  AWARE_GPS = "AWARE_GPS",
  COMMAND_GPS = "COMMAND_GPS",
  FLEETSHARP = "FLEETSHARP",
  ELD_RIDER_PRO = "ELD_RIDER_PRO",
  SHELD = "SHELD",
  XELD = "XELD",
  ZELD = "ZELD",
  EVA_ELD = "EVA_ELD",
  XPLORE_ELD = "XPLORE_ELD",
  OPTIMA_ELD = "OPTIMA_ELD",
  PRO_RIDE_ELD = "PRO_RIDE_ELD",
  SPARKLE_ELD = "SPARKLE_ELD",
  APEX_ELD = "APEX_ELD",
  ROCK_ELD = "ROCK_ELD",
  REQUEST = "REQUEST",
  TELETRAC_NAVMAN = "TELETRAC_NAVMAN",
  GORILLA_SAFETY = "GORILLA_SAFETY",
  CLUTCH_ELD = "CLUTCH_ELD",
  CYNTRX_ELD_PLUS = "CYNTRX_ELD_PLUS",
  ELD_MANDATE_PRO = "ELD_MANDATE_PRO",
  // FLEET_LOCATE_ELD = "FLEET_LOCATE_ELD",
  PATRIOT = "PATRIOT",
  SIMPLEX_ELD = "SIMPLEX_ELD",
  TRACK_ON_ELD = "TRACK_ON_ELD",
  TRUCKER_PATH_ELD_PRO = "TRUCKER_PATH_ELD_PRO",
  INTELLISHIFT = "INTELLISHIFT",
  EZ_FLEET = "EZ_FLEET",
  SIMPLE_TRUCK_ELD = "SIMPLE_TRUCK_ELD",
  GLOBAL_ELD = "GLOBAL_ELD",
  SIMPLE_E_LOG = "SIMPLE_E_LOG",
  MICHELIN_CONNECTED_FLEET = "MICHELIN_CONNECTED_FLEET",
  GPS_TRACKIT = "GPS_TRACKIT",
  INTOUCH_GPS = "INTOUCH_GPS",
  BRICKHOUSE_SECURITY = "BRICKHOUSE_SECURITY",
  TERMINUS_GPS_ELD = "TERMINUS_GPS_ELD",
  BRANIX = "BRANIX",
  BLUE_INK = "BLUE_INK",
  TX_ELD = "TX_ELD",
  POP_ELD = "POP_ELD",
  NEXTRAQ_MARCUS = "NEXTRAQ_MARCUS",
  PEAK_ELD = "PEAK_ELD",
  SURFSIGHT = "SURFSIGHT",
  // HOS Connect and resellers
  HOS_247 = "HOS_247",
  BLACK_BEAR_ELD = "BLACK_BEAR_ELD",
  COLUMBUS_ELD = "COLUMBUS_ELD",
  STATE_ELOG = "STATE_ELOG",
  DY_ELD = "DY_ELD",
  _3PL_TEK = "_3PL_TEK",
  ABC_ELD = "ABC_ELD",
  ACTION_ELD = "ACTION_ELD",
  ADVANTAGE_KNIGHTS_ELD = "ADVANTAGE_KNIGHTS_ELD",
  ALPHA_E_LOGBOOK = "ALPHA_E_LOGBOOK",
  AMPM_ELD = "AMPM_ELD",
  BISON_ELOG = "BISON_ELOG",
  CAPTAIN_ELD = "CAPTAIN_ELD",
  COBRA_ELD = "COBRA_ELD",
  DAILY_ELD = "DAILY_ELD",
  DFL_ELD = "DFL_ELD",
  DIGITAL_ELD = "DIGITAL_ELD",
  DLOG_ELD = "DLOG_ELD",
  DYNAMIC_ELD = "DYNAMIC_ELD",
  EGREEN_ELD = "EGREEN_ELD",
  ELD_FOR_YOU = "ELD_FOR_YOU",
  ELD2GO = "ELD2GO",
  ELD4TRUCKING = "ELD4TRUCKING",
  ELOG42 = "ELOG42",
  EXTREME_ELD = "EXTREME_ELD",
  FLASH_ELOGS = "FLASH_ELOGS",
  GLOBCOM_ELD = "GLOBCOM_ELD",
  HERO_ELD = "HERO_ELD",
  INFINITY_ELD = "INFINITY_ELD",
  IRONMAN_ELD = "IRONMAN_ELD",
  JUST_ELD = "JUST_ELD",
  LEGACY_ELD = "LEGACY_ELD",
  LOG_PLUS_ELD = "LOG_PLUS_ELD",
  MOONLIGHT_ELD = "MOONLIGHT_ELD",
  NOOR_ELD = "NOOR_ELD",
  NOVIO_ELD = "NOVIO_ELD",
  ORIENT_STAR_ELD = "ORIENT_STAR_ELD",
  PARAGON_ELD = "PARAGON_ELD",
  PHOENIX_ELD = "PHOENIX_ELD",
  PIONEER_ELD_SOLUTION = "PIONEER_ELD_SOLUTION",
  POWERTRUCKS_ELD = "POWERTRUCKS_ELD",
  PROJECT_ELD = "PROJECT_ELD",
  QUICK_ELOGS_ELD = "QUICK_ELOGS_ELD",
  RENAISSANCE_ELD = "RENAISSANCE_ELD",
  ROBINHOOD_ELD = "ROBINHOOD_ELD",
  ROUTE_ELD = "ROUTE_ELD",
  RUN_ELD = "RUN_ELD",
  SBA_ELD = "SBA_ELD",
  SF_ELD = "SF_ELD",
  SIMBA_ELD = "SIMBA_ELD",
  SMART_CHOICE_LOGS = "SMART_CHOICE_LOGS",
  SPEEDLINE_ELD = "SPEEDLINE_ELD",
  STARWAY_ELD = "STARWAY_ELD",
  SUPPORT_ELD = "SUPPORT_ELD",
  TEDDY_ELD = "TEDDY_ELD",
  TEMPUS_ELD = "TEMPUS_ELD",
  TRUE_ROAD_ELD = "TRUE_ROAD_ELD",
  TRUST_ELD = "TRUST_ELD",
  UNDER_CONTROL_ELD = "UNDER_CONTROL_ELD",
  UNITY_ELD = "UNITY_ELD",
  VLOG_ELD = "VLOG_ELD",
  XPERT_LOGS = "XPERT_LOGS",
  YOULOG_ELD = "YOULOG_ELD",
  ZAPHIRA_ELD = "ZAPHIRA_ELD",
  EBLUE_SUN_LOGS = "EBLUE_SUN_LOGS",
  ELD_DESIRED = "ELD_DESIRED",
  FIRSTGATE_ELD = "FIRSTGATE_ELD",
  GRAND_ELD = "GRAND_ELD",
  ILOG_ELD = "ILOG_ELD",
  PLATINUM_ELD = "PLATINUM_ELD",
  READYSETPIPE_ELD = "READYSETPIPE_ELD",
  RED_FOX_ELD = "RED_FOX_ELD",
  REGULOG_ELD = "REGULOG_ELD",
  SUBSET_LOGBOOK = "SUBSET_LOGBOOK",
  UNIQUE_ELD = "UNIQUE_ELD",
  TOP_COMPLIANCE_ELD = "TOP_COMPLIANCE_ELD",
  OMEGA_ELD = "OMEGA_ELD",
  RIDEHUB_ELD = "RIDEHUB_ELD",
  TRACK_TRUCK = "TRACK_TRUCK",
  TRUCKSTAFF_ELD = "TRUCKSTAFF_ELD",
  DRAGON_ELD = "DRAGON_ELD",
  FLEX_ELD = "FLEX_ELD",
  HIGHEST_GEARS = "HIGHEST_GEARS",
  PDSYNC_ELD = "PDSYNC_ELD",
  TRUCK_FORD_ELD = "TRUCK_FORD_ELD",
  ASAP_ELD = "ASAP_ELD",
  EXTENDED_ROAD_ELD = "EXTENDED_ROAD_ELD",
  AUTOGRI_ELD = "AUTOGRI_ELD",
  AVANGUARD_ELD = "AVANGUARD_ELD",
  AXIOS_ELD = "AXIOS_ELD",
  BELLFAM_ELD = "BELLFAM_ELD",
  BEST_SOURCE_ELD = "BEST_SOURCE_ELD",
  BOLT_ELD = "BOLT_ELD",
  DOCUDRIVE_ELD = "DOCUDRIVE_ELD",
  RING_ELD = "RING_ELD",
  EXPRESS_WAY_ELD = "EXPRESS_WAY_ELD",
  LOOKTRUCK_ELD = "LOOKTRUCK_ELD",
  RS_ELD = "RS_ELD",
  VRH_ELD = "VRH_ELD",
  LOGS_SKI_ELD = "LOGS_SKI_ELD",
  TURNSBUSS = "TURNSBUSS",
  PREMIERRIDE_LOGS = "PREMIERRIDE_LOGS",
  SIMPLEWAY_ELD = "SIMPLEWAY_ELD",
  OZOD_EXPRESS_ELD = "OZOD_EXPRESS_ELD",
  MAP_ELOG = "MAP_ELOG",
  AM_LOGS_ELD = "AM_LOGS_ELD",
  _48_ELD = "_48_ELD",
  ROYAL_ELD = "ROYAL_ELD",
  INSPIRE_ELD = "INSPIRE_ELD",
  SPLIT_ELD = "SPLIT_ELD",
  ELD_ROAD_HOS = "ELD_ROAD_HOS",
  // Trackensure resellers
  TRACKENSURE = "TRACKENSURE",
  SWIFT_ELD = "SWIFT_ELD",
  SWITCHBOARD = "SWITCHBOARD",
  AMBER_ELD = "AMBER_ELD",
  CLUB_ELD = "CLUB_ELD",
  ELD_PRO_SOLUTION = "ELD_PRO_SOLUTION",
  PROTRACKING_ELD = "PROTRACKING_ELD",
  SHARP_ELD = "SHARP_ELD",
  VISTA_ELD = "VISTA_ELD",
  ZENITH_ELD = "ZENITH_ELD",
  ADA_ELD = "ADA_ELD",
  ALFA_ELD = "ALFA_ELD",
  ENSI_LOG = "ENSI_LOG",
  INTERSTATE_FREEWAY = "INTERSTATE_FREEWAY",
  SMART_ELOG = "SMART_ELOG",
  SPRINT_ELD = "SPRINT_ELD",
  TRIP_ELD = "TRIP_ELD",
  _24HOS_ELD = "_24HOS_ELD",
  FORTUNE_ELD = "FORTUNE_ELD",
  ORION_ELD = "ORION_ELD",
  PHANTOM_ELD = "PHANTOM_ELD",
  TRENDY_ELD = "TRENDY_ELD",
  VECTOR_ELD = "VECTOR_ELD",
  WHEELS_ELOG = "WHEELS_ELOG",
  MATRACK = "MATRACK",
  VOYOMOTIVE = "VOYOMOTIVE",
  VESTIGE = "VESTIGE",
  GTS = "GTS",
  // GPSTAB resellers
  GPSTAB = "GPSTAB",
  MAX_ELD = "MAX_ELD",
  MOUNTAIN_ELD = "MOUNTAIN_ELD",
  ELD_ONE = "ELD_ONE",
  ROADSTAR_ELD = "ROADSTAR_ELD",
  MASTER_ELD = "MASTER_ELD",
  REAL_ELD = "REAL_ELD",
  TFM_ELD = "TFM_ELD",
  FM_ELD = "FM_ELD",
  LIGHT_AND_TRAVEL_ELD = "LIGHT_AND_TRAVEL_ELD",
  ID_ELD = "ID_ELD",
  NEO_ELD = "NEO_ELD",
  COGO_ELD = "COGO_ELD",
  DIALOG_ELD = "DIALOG_ELD",
  FLEETHUNT = "FLEETHUNT",
  // Reliable ELD resellers
  RELIABLE_ELD = "RELIABLE_ELD",
  AT_ELD = "AT_ELD",
  MGK_ELD = "MGK_ELD",
  NOOR_ELD_SOLUTION = "NOOR_ELD_SOLUTION",
  ORIENT_ELD = "ORIENT_ELD",
  AXION_ROUTE = "AXION_ROUTE",
  // TT ELD resellers
  TT_ELD = "TT_ELD",
  EVO_ELD = "EVO_ELD",
  ONTIME_LOGS = "ONTIME_LOGS",
  ZIPPY_ELD = "ZIPPY_ELD",
  ONTIME_ELD = "ONTIME_ELD",
  FIVE_ELD = "FIVE_ELD",
  LOGFLEET_ELD = "LOGFLEET_ELD",
  SUN_ELD = "SUN_ELD",
  FLEET_VISION = "FLEET_VISION",
  // Drive HOS resellers
  DRIVE_HOS = "DRIVE_HOS",
  FACTOR_ELD = "FACTOR_ELD",
  DAILY_ELD_PLUS = "DAILY_ELD_PLUS",
  DSG_LOGS = "DSG_LOGS",
  DY_PLUS_ELD = "DY_PLUS_ELD",
  EGREEN_ELD_PRO = "EGREEN_ELD_PRO",
  UZBPRIME_ELD = "UZBPRIME_ELD",
  ILOG_ELD_APP = "ILOG_ELD_APP",
  LEADER_ELD = "LEADER_ELD",
  LUCID_ELD = "LUCID_ELD",
  PANDA_ELD = "PANDA_ELD",
  PRESTIGE_ELD = "PRESTIGE_ELD",
  STARTRUCKS_ELD = "STARTRUCKS_ELD",
  US_FAST_ELD = "US_FAST_ELD",
  US_POWER_ELD = "US_POWER_ELD",
  VITALITY_ELD = "VITALITY_ELD",
  ZEROMAX_ELD = "ZEROMAX_ELD",
  BLUE_STAR_ELD = "BLUE_STAR_ELD",
  SECURE_PATH_ELD = "SECURE_PATH_ELD",
  FIRST_ELD = "FIRST_ELD",
  DRIVE_LENS_ELD = "DRIVE_LENS_ELD",
  NIGHT_WATCH_ELD = "NIGHT_WATCH_ELD",
  _ELD88 = "_ELD88",
  AFS_WORLD_ELD = "AFS_WORLD_ELD",
  HUNTER_ELD = "HUNTER_ELD",
  REMAX_ELD = "REMAX_ELD",
  EZ_TO_TRACK = "EZ_TO_TRACK",
  GOOD_DEAL_GPS = "GOOD_DEAL_GPS",
  HOS_ELD = "HOS_ELD",
  TRANSIT_TRACKING = "TRANSIT_TRACKING",
  MT_ELD = "MT_ELD",
  EAGLE_ELD = "EAGLE_ELD",
  SMART_WAY_ELD = "SMART_WAY_ELD",
  OXEMON = "OXEMON",
  ROUTELINK_IO = "ROUTELINK_IO",
  ELD4_TRUCKS = "ELD4_TRUCKS",
  ATINA_ELD = "ATINA_ELD",
  UNIFY_ELD = "UNIFY_ELD",
  ELD_RUN = "ELD_RUN",
  TERA_HUB = "TERA_HUB",
  HOBBS_ELD = "HOBBS_ELD",
  PINNACLE_ELD = "PINNACLE_ELD",
  MEMENTO_ELD = "MEMENTO_ELD",
  HORIZONT_PATH_ELD = "HORIZONT_PATH_ELD",
  NOMAD_ELD = "NOMAD_ELD",
  TXT_ELD = "TXT_ELD",
  PAYD_ELD = "PAYD_ELD",
  HUTCH_SYSTEMS = "HUTCH_SYSTEMS",
}
